import { render, staticRenderFns } from "./PhotoRecorder.vue?vue&type=template&id=2bb48782&"
import script from "./PhotoRecorder.vue?vue&type=script&lang=js&"
export * from "./PhotoRecorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports